import React from "react"
import { useEffect, useState } from "react"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import Button from "@mui/material/Button"
import DialogActions from "@mui/material/DialogActions"
import DialogTitle from "@mui/material/DialogTitle"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import Box from "@mui/material/Box"
import { billing } from "../../ajax_clients/billing"

// NOTE: There is another version of this component in the frontend app so if you're making changes here make sure to make them there as well.
// It lives at frontend/src/components/shared/billing_address_prompt.tsx
export default function BillingAddressPrompt() {
  const [loaded, setLoaded] = useState(false)
  const [open, setOpen] = useState(false)
  const [shown, setShown] = useState(false)

  useEffect(() => {
    if (shown) {
      return
    }

    // Don't show the prompt if the user is on a billing page
    if (window?.location?.pathname?.includes("/billing")) {
      setOpen(false)
      return
    }

    if (loaded) {
      return
    }

    billing.showAddressAlert().then((response) => {
      setLoaded(true)
      if (response.data.required && !response.data.shown) {
        setOpen(true)
        setShown(true)
      }
    })
  }, [loaded, setLoaded, shown])

  const handleClose = () => {
    setOpen(false)
    billing.dismissAddressAlert()
  }

  const handleConfirm = () => {
    setOpen(false)
    // Wait for the dismiss call to complete before navigating
    // Otherwise the session may not be updated yet and they will see the prompt again when they navigate
    // to the billing page
    billing.dismissAddressAlert({verify: true}).then(() => {
      window.location = "/admin/v2/billing/payment"
    })
  }

  if (!loaded) {
    return null
  }

  return (
    <>
      <Dialog
        open={open}
        disableEscapeKeyDown
        aria-labelledby="billing-address-alert-title"
        aria-describedby="billing-address-alert-description"
      >
        <DialogContent>
          <DialogTitle
            id="billing-address-alert-title"
            sx={{ padding: "0 0 16px 0", fontSize: "1.25rem"  }}
          >
            <Box display="flex" alignItems="center">
              <Box flexGrow={1}>Billing Address Required</Box>
              <Box>
                <IconButton aria-label="Dismiss" onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>

          <DialogContentText id="billing-address-alert-description">
            Please update and verify your billing address. Click to view and
            edit your organization&#39;s billing information.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleConfirm}
            autoFocus
            color="primary"
            variant="contained"
          >
            Verify Address
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
